@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.voiceassistant

import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.voiceassistant.VoiceAssistantSessionLogDto

object GetVoiceAssistantSessionsEndpoint :
    EndPoint<GetVoiceAssistantSessionsEndpoint.Request, GetVoiceAssistantSessionsEndpoint.Response>() {
    class Request(
        val pageNo: Int,
        val pageSize: Int,
        val searchTerm: String?,
    )

    class Response(
        val list: Array<VoiceAssistantSessionLogDto>,
        val total: Int,
    )
}
